import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { ChevronLeft, MoreVertical } from 'lucide-react'
import ProjectAssetsOverview from '../components/ProjectAssetsOverview'
import { useProjectsStore } from '../stores/projectsStore'
import { projectsApiService, type ProjectApiResponse } from '../services/projectsApi'

const ProjectDetails = () => {
  const { projectId = '' } = useParams()
  const { projects } = useProjectsStore()
  
  const [projectDetails, setProjectDetails] = useState<ProjectApiResponse | null>(null)
  const [loading, setLoading] = useState(false)

  // Try to get project from store first, otherwise fetch it
  useEffect(() => {
    const projectInStore = projects.find(p => p._id === projectId)
    
    if (projectInStore) {
      // Convert store project to API response format
      setProjectDetails(projectInStore as any)
    } else if (projectId) {
      // Fetch project details from API
      const fetchProjectDetails = async () => {
        try {
          setLoading(true)
          const response = await projectsApiService.getProjectById(projectId)
          if (response.success && response.data) {
            setProjectDetails(response.data)
          }
        } catch (error) {
          console.error('Failed to fetch project details:', error)
        } finally {
          setLoading(false)
        }
      }
      
      fetchProjectDetails()
    }
  }, [projectId, projects])

  const projectName = projectDetails?.name || projectId
  const projectTenantId = projectDetails?.tenantId || ''

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link to="/projects" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white">
            <ChevronLeft className="h-4 w-4 mr-1" /> Back to Projects
          </Link>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{projectName}</h1>
        </div>
        <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md">
          <MoreVertical className="h-5 w-5" />
        </button>
      </div>

      <ProjectAssetsOverview projectId={projectId} projectName={projectName} projectTenantId={projectTenantId} />
    </div>
  )
}

export default ProjectDetails


